import { CloseOutlined } from '@ant-design/icons';
import { Button, Heading } from '@mm/components';
import { useEmailAccountCRUDActions } from '@mm/state/actions/EmailAccountCRUDActions';
import { useViewActions } from '@mm/state/actions/viewActions';
import { EmailAccount } from '@mm/state/interfaces/emailAccount';
import { selectAllEmailAccounts } from '@mm/state/selectors/emailAccountsSelectors';
import { Input } from 'antd';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { SlideoutMenu } from '../../components/SlideoutMenu';
import { useSlideoutOnClose } from '../SlideoutEmail/SlideoutEmail';

import styles from './SendingDomainFromNameSlideout.module.css';

export type SendingDomainFromNameSlideoutProps = {
  emailAccount?: EmailAccount;
  domain: string;
  facebookPageId: number;
};

export const SendingDomainFromNameSlideout = ({
  emailAccount,
  domain,
  facebookPageId,
}: SendingDomainFromNameSlideoutProps) => {
  const { name } = emailAccount || {};
  const sendgridAccounts = useSelector(selectAllEmailAccounts).filter(
    acc => acc.kind === 'sendgrid_platform',
  );

  const [input, setInput] = useState(name);
  const [busy, setBusy] = useState(false);
  const [touched, setTouched] = useState(false);

  const hasName = !!sendgridAccounts.find(acc => acc.name === input);

  const { update, create } = useEmailAccountCRUDActions();
  const viewActions = useViewActions();
  const onClose = () => onBeforeClose(name, input);
  const { setRef, onBeforeClose } = useSlideoutOnClose(onClose);

  const close = async () => {
    try {
      await onClose();
      viewActions.hideSlideoutMenu();
    } catch (err) {}
  };

  const hasChanges = name !== input;

  const updateName = async () => {
    if (input?.length) {
      setBusy(true);
      if (emailAccount) {
        await update({ ...emailAccount, name: input });
      } else {
        create({
          name: input,
          emailAddress: `${input}@${domain}`,
          facebookPageId,
          kind: 'sendgrid_platform',
        });
      }

      setBusy(false);
    }
    viewActions.hideSlideoutMenu();
  };

  return (
    <SlideoutMenu className={styles.menu} setRef={setRef}>
      <div className={styles.headerContent}>
        <Heading className={styles.headerTitle} size={3}>
          Sending Name
        </Heading>

        <div className={styles.headerButtons}>
          <Button
            css={{ container: styles.button }}
            onClick={updateName}
            disabled={!input?.length || busy || !hasChanges || hasName}
          >
            Save
          </Button>
          <CloseOutlined onClick={close} className={styles.closeIcon} />
        </div>
      </div>
      <SlideoutMenu.Content className={styles.content}>
        <div className={styles.box}>
          <Input
            rootClassName={styles.input}
            value={input}
            onChange={e => {
              setTouched(true);
              setInput(e.target.value.trim().toLowerCase());
            }}
            suffix={`@${domain}`}
            status={hasName && touched ? 'error' : ''}
            placeholder="Sender name e.g. contact"
          />
        </div>
        {hasName && touched && (
          <div style={{ color: '#ff4d4f', padding: '2px 20px' }}>
            Name already exists
          </div>
        )}
      </SlideoutMenu.Content>
    </SlideoutMenu>
  );
};
